module.exports = __webpack_public_path__ + "img/beaver__logo.0423bf68.png";